import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    batchClassList: [],
    totalRecords: 0,
    message: null,
    batchClassDetails: {},
    batchTypeList: [],
    batchClass: null,
    courseList: [],
    batchList: [],
    subjectList: [],
    topicList: [],
    teacherList: [],
    upcomingLiveClasses: [],
    classTypeList: [],
    batchClassDetailsLoading: false,
    batchClassDetailsSuccess: null,
    batchClassDetailsError: '',
    allbatchClassLoading: false,
    allBatchClassSuccess: null,
    allbatchClassError: '',
    upcomingLiveClassesLoading: false,
    upcomingLiveClassesSuccess: null,
    upcomingLiveClassesError: '',
    // TODO:
    selectedBatch: {
        courseList: [],
        batchList: [],
        subjectList: [],
        topicList: [],
        teacherList: [],

    },
    selectedId: {
        courseList: [],
        batchList: [],
        subjectList: [],
        topicList: [],
        teacherList: [],
    },
    batchClassesByCourseIdAndBatchId: [],
    batchByCourseId: [],
    attendanceList: [],
    batchClassCalendarLoading: false,
    batchClassCalendarSuccess: [],
    batchClassCalendarError: "",

    teacherAttendanceListLoading: false,
    teacherAttendanceListSuccess: {},
    teacherAttendanceListError: "",

    teacherEngagementListLoading: false,
    teacherEngagementListSuccess: {},
    teacherEngagementListError: "",
    allTimeTableLoading: false,
    allTimeTablesSuccess: {},
    allTimeTableError: '',
    attendanceLoading: false,
    attendancesSuccess: {},
    attendanceError: '',
    liveClassParticipantLoading: false,
    liveClassParticipantsSuccess: {},
    liveClassParticipantError: '',
    manageLiveClassesLoading: false,
    manageLiveClassesSuccess: {},
    manageLiveClassesError: ''

}


export const batchClassTypeSlice = createSlice({
    name: 'batch-class',
    initialState,
    reducers: {
        getBatchClassList: (state, action) => {
            state.batchClassList = action.payload?.data?.data;
            state.totalRecords = action.payload?.data?.totalRecord;
            state.message = action.payload?.message
        },
        setAllBatchClassLoading: (state, action) => {
            state.allbatchClassLoading = true;
            state.allBatchClassSuccess = null;
            state.allbatchClassError = '';
        },
        setAllBatchClassSuccess: (state, action) => {
            state.allbatchClassLoading = false;
            state.allBatchClassSuccess = action.payload;
            state.allbatchClassError = '';
        },
        setAllBatchClassError: (state, action) => {
            state.allbatchClassLoading = false;
            state.allBatchClassSuccess = null;
            state.allbatchClassError = action.payload;
        },
        getBatchClassDetails: (state, action) => {
            state.batchClassDetails = action.payload
        },
        setBatchClassDetailsLoading: (state, action) => {
            state.batchClassDetailsLoading = true;
            state.batchClassDetailsSuccess = null;
            state.batchClassDetailsError = '';
        },
        setBatchClassDetailsSuccess: (state, action) => {
            state.batchClassDetailsLoading = false;
            state.batchClassDetailsSuccess = action.payload;
            state.batchClassDetailsError = '';
        },
        setBatchClassDetailsError: (state, action) => {
            state.batchClassDetailsLoading = false;
            state.batchClassDetailsSuccess = null;
            state.batchClassDetailsError = action.payload;
        },
        setUpcomingLiveClassLoading: (state, action) => {
            state.upcomingLiveClassesLoading = true;
            state.upcomingLiveClassesSuccess = null;
            state.upcomingLiveClassesError = '';
        },
        setUpcomingLiveClassSuccess: (state, action) => {
            state.upcomingLiveClassesLoading = false;
            state.upcomingLiveClassesSuccess = action.payload
            state.upcomingLiveClassesError = '';
        },
        setUpcomingLiveClassError: (state, action) => {
            state.upcomingLiveClassesLoading = false;
            state.upcomingLiveClassesSuccess = null;
            state.upcomingLiveClassesError = action.payload
        },
        getBatchClassById: (state, action) => {
            state.batchTypeList = action.payload.batchTypeList;
            state.classTypeList = action.payload.liveClassTypeList;
            // state.courseList = action.payload.courses;
            state.batchClass = action.payload;

        },
        getBatchByCourseId: (state, action) => {
            // state.batchList = action.payload;
            state.batchList = action.payload?.map((item) => ({
                ...item,
                value: item.id,
                label: item.name,
            }))
        },
        subjectsByCourseId: (state, action) => {
            state.subjectList = action.payload?.map((item) => ({
                ...item,
                value: item.id,
                label: item.name,
            }))
        },
        getTopicsByCourseId: (state, action) => {
            state.topicList = action.payload?.map((item) => ({
                ...item,
                value: item.id,
                label: item.name,
            }))
        },
        teacherBySubjectId: (state, action) => {
            state.teacherList = action.payload?.map((item) => ({
                ...item,
                value: item.id,
                label: item.name,
            }))

        },
        // new reducer  with all state management

        setBatchClassesByCourseIdAndBatchId: (state, action) => {
            state.batchClassesByCourseIdAndBatchId = action.payload?.map((item) => ({ ...item, label: item.title, value: item.id }))
        },
        setBatchClassesByCourseId: (state, action) => {
            state.batchByCourseId = action.payload.data.map((item) => ({ ...item, label: item.name, value: item.id }))
        },
        setBatchClassesBySearch: (state, action) => {
            state.batches = action.payload.data.map((item) => ({ ...item, label: item.name, value: item.id }))
        },
        setBatchClassAttendance: (state, action) => {
            state.attendanceList = action.payload
        },
        resetAllState: (state, action) => {
            state.courseList = []
            state.batchList = []
            state.subjectList = []
            state.teacherList = []
        },
        resetTeacherList: (state, action) => {
            state.teacherList = []
        },
        resetTopicsList: (state, action) => {
            state.topicList = []
        },
        resetBatchClass: (state, action) => {
            state.batchClass = null
        },
        resetTimeTableList: (state, action) => {
            state.allTimeTablesSuccess = null
        },


        // batchclass calendar

        getBatchClassCalendarLoading: (state, action) => {
            state.batchClassCalendarLoading = true;
            state.batchClassCalendarSuccess = []
        },
        getBatchClassCalendarSuccess: (state, action) => {
            state.batchClassCalendarLoading = false;
            state.batchClassCalendarSuccess = action.payload.data

        },
        getBatchClassCalendarError: (state, action) => {
            state.batchClassCalendarLoading = false;
            state.batchClassCalendarSuccess = [];
            state.batchClassCalendarError = action.payload.message

        },

        setBatchTeacherAttendanceLoading: (state, action) => {
            state.teacherAttendanceListLoading = true;
            state.teacherAttendanceListSuccess = {};
            state.teacherAttendanceListError = "";

        },

        setBatchTeacherAttendanceSuccess: (state, action) => {
            state.teacherAttendanceListLoading = false;
            state.teacherAttendanceListSuccess = action.payload;
            state.teacherAttendanceListError = "";
        },
        setBatchTeacherAttendanceError: (state, action) => {
            state.teacherAttendanceListLoading = false;
            state.teacherAttendanceListSuccess = {}
            state.teacherAttendanceListError = action.payload.message
        },
        setDownloadTeacherEngagementLoading: (state, action) => {
            state.teacherEngagementListLoading = true
            state.teacherEngagementListSuccess = {}
            state.teacherEngagementListError = ""

        },
        setDownloadTeacherEngagementSuccess: (state, action) => {
            state.teacherEngagementListLoading = false
            state.teacherEngagementListSuccess = action.payload
            state.teacherEngagementListError = ""

        },
        setDownloadTeacherEngagementError: (state, action) => {
            state.teacherEngagementListLoading = false
            state.teacherEngagementListSuccess = {}
            state.teacherEngagementListError = action.payload.message
        },
        setAllTimeTableLoading: (state, action) => {
            state.allTimeTableLoading = true;
            state.allTimeTablesSuccess = null;
            state.allTimeTableError = '';
        },
        setAllTimeTableSuccess: (state, action) => {
            state.allTimeTableLoading = false;
            state.allTimeTablesSuccess = action.payload;
            state.allTimeTableError = '';
        },
        setAllTimeTableError: (state, action) => {
            state.allTimeTableLoading = false;
            state.allTimeTablesSuccess = null;
            state.allTimeTableError = action.payload;
        },
        setAttendanceLoading: (state, action) => {
            state.attendanceLoading = true;
            state.attendancesSuccess = null;
            state.attendanceError = '';
        },
        setAttendanceSuccess: (state, action) => {
            state.attendanceLoading = false;
            state.attendancesSuccess = action.payload;
            state.attendanceError = '';
        },
        setAttendanceError: (state, action) => {
            state.attendanceLoading = false;
            state.attendancesSuccess = null;
            state.attendanceError = action.payload;
        },
        setLiveClassParticipantLoading: (state, action) => {
            state.liveClassParticipantLoading = true;
            state.liveClassParticipantsSuccess = null;
            state.liveClassParticipantError = '';
        },
        setLiveClassParticipantSuccess: (state, action) => {
            state.liveClassParticipantLoading = false;
            state.liveClassParticipantsSuccess = action.payload;
            state.liveClassParticipantError = '';
        },
        setLiveClassParticipantError: (state, action) => {
            state.liveClassParticipantLoading = false;
            state.liveClassParticipantsSuccess = null;
            state.liveClassParticipantError = action.payload;
        },
        setManageLiveClassesLoading: (state, action) => {
            state.manageLiveClassesLoading = true;
            state.manageLiveClassesSuccess = null;
            state.manageLiveClassesError = '';
        },
        setManageLiveClassesSuccess: (state, action) => {
            state.manageLiveClassesLoading = false;
            state.manageLiveClassesSuccess = action.payload;
            state.manageLiveClassesError = '';
        },
        setManageLiveClassesError: (state, action) => {
            state.manageLiveClassesLoading = false;
            state.manageLiveClassesSuccess = null;
            state.manageLiveClassesError = action.payload;
        },


    },
})

// Action creators are generated for each case reducer function
export const { getBatchClassList, getBatchClassDetails, getBatchClassById, getBatchByCourseId, subjectsByCourseId, getTopicsByCourseId,
    teacherBySubjectId, handleSelectBatch, handleFillDetails, resetAllState, resetBatchClass, resetTeacherList, resetTopicsList, getUpcomingLiveClass, setBatchClassDetailsLoading, setBatchClassDetailsSuccess, setBatchClassDetailsError, setAllBatchClassLoading, setAllBatchClassSuccess, setAllBatchClassError, setUpcomingLiveClassLoading, setUpcomingLiveClassSuccess,
    setUpcomingLiveClassError, setBatchClassesByCourseIdAndBatchId,
    setBatchClassesByCourseId, setBatchClassesBySearch, setBatchClassAttendance,
    getBatchClassCalendarLoading
    , getBatchClassCalendarSuccess,
    setBatchTeacherAttendanceLoading,
    setBatchTeacherAttendanceSuccess,
    setBatchTeacherAttendanceError,
    getBatchClassCalendarError,
    setDownloadTeacherEngagementLoading,
    setDownloadTeacherEngagementSuccess,
    setDownloadTeacherEngagementError,
    setAllTimeTableLoading,
    setAllTimeTableSuccess,
    setAllTimeTableError,
    setManageLiveClassesLoading,
    setManageLiveClassesSuccess,
    setManageLiveClassesError,
    setAttendanceLoading,
    setAttendanceSuccess,
    setAttendanceError,
    setLiveClassParticipantLoading,
    setLiveClassParticipantSuccess,
    setLiveClassParticipantError,
    resetTimeTableList
} = batchClassTypeSlice.actions

export default batchClassTypeSlice.reducer;